export default __webpack_public_path__ + "static/media/lumenai_helper.2f2cf128.svg";